import { render } from "./SiteMemorial.vue?vue&type=template&id=30e43d6f"
import script from "./SiteMemorial.vue?vue&type=script&lang=js"
export * from "./SiteMemorial.vue?vue&type=script&lang=js"

import "./SiteMemorial.vue?vue&type=style&index=0&id=30e43d6f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__